:host(:not([auto-color])) {
  /**
  * @prop --icon-color: Color of the icon (sets the SVG's `fill` property)
  */
}
:host(:not([auto-color])) svg * {
  fill: var(--icon-color) !important;
}
:host(:not([auto-color])) path.icons01 {
  fill: var(--icons01-enabled);
}
:host(:not([auto-color])) path.icons02 {
  fill: var(--icons02-enabled);
}
:host(:not([auto-color])) path.icons03 {
  fill: var(--icons03-enabled);
}
:host(:not([auto-color])) path.icons04 {
  fill: var(--icons04-enabled);
}
:host(:not([auto-color])) path.icons05 {
  fill: var(--icons05-enabled);
}
:host(:not([auto-color])) path.icons06 {
  fill: var(--icons06-enabled);
}
:host(:not([auto-color])) path.icons07 {
  fill: var(--icons07-enabled);
}
:host(:not([auto-color])) path.icons08 {
  fill: var(--icons08-enabled);
}
:host(:not([auto-color])) path.icons09 {
  fill: var(--icons09-enabled);
}

:host {
  /**
  * @prop --icon-size: Size of the icon (sets both width and height)
  */
  display: inline-flex;
  line-height: 0;
}
:host svg {
  width: var(--icon-size);
  height: var(--icon-size);
}